// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './subscriptions.es-AR.json';
import esMX from './subscriptions.es-MX.json';
import ptBR from './subscriptions.pt-BR.json';

const subscriptionTranslations: DomainTranslations = {
  name: 'subscriptions',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
    [Locale.COLOMBIA]: esMX,
    [Locale.CHILE]: esMX,
  },
};

export default subscriptionTranslations;
